import React from "react";
import { Modal, Input, Form } from "antd";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { getError } from "../../utils/form";
const { TextArea } = Input;
const schema = yup.object().shape({
  instruction: yup.string().required("Field can't be empty"),
});

const ControlledInput = ({ control, errors, name, label, required }) => {
  const error = getError({ errors, name });
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Form.Item
          required={required}
          validateStatus={error ? "error" : "success"}
          help={error?.message}
        >
          <TextArea rows={4} {...field} />
        </Form.Item>
      )}
    />
  );
};

const AddInstructionsForm = ({ visible, setVisible, onSave }) => {
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      instruction: "",
    },
    resolver: yupResolver(schema),
  });

  const onSubmit = (data) => {
    onSave(data);
  };

  const handleCancel = () => {
    reset();
    setVisible(false);
  };

  return (
    <Modal
      title="Add Instructions"
      visible={visible}
      okText="Save"
      onOk={handleSubmit(onSubmit)}
      onCancel={handleCancel}
    >
      <ControlledInput
        required={true}
        control={control}
        name="instruction"
        errors={errors}
      />
    </Modal>
  );
};

export default AddInstructionsForm;
